/* =============================================================
   TRUST BAND — Certifications, partner logos, and key credentials
   Addresses: No trust signals on original site
   ============================================================= */

import { Shield, CheckCircle, Award, Clock } from "lucide-react";

const trustItems = [
  { icon: Shield, label: "Registered BAS Agent", sub: "Agent No. 262 458 37" },
  { icon: Award, label: "Xero Certified Advisor", sub: "Gold Partner" },
  { icon: CheckCircle, label: "ABN Registered", sub: "ABN 87 148 349 750" },
  { icon: Clock, label: "Weekly Reconciliation", sub: "Always Up-to-Date" },
];

export default function TrustBand() {
  return (
    <section className="bg-[oklch(0.26_0.065_250)] py-10 border-y border-white/10">
      <div className="container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-[oklch(0.72_0.12_75)/0.15] flex items-center justify-center">
                <item.icon size={18} className="text-[oklch(0.72_0.12_75)]" />
              </div>
              <div>
                <div className="text-white text-sm font-semibold leading-tight" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                  {item.label}
                </div>
                <div className="text-white/50 text-xs mt-0.5" style={{ fontFamily: "'DM Mono', monospace" }}>
                  {item.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
